<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Images
                        <Loader v-if="isImagesPending"
                                class="-sm ml-2"/>
                    </span>
                </span>
                <span>
                    <button type="button" @click.prevent="handleUploadMedias"
                            class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Ajouter des images
                    </button>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <div class="bg-white max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                    <button @click.prevent="handleSelectAll"
                            class="mr-2 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm border border-cyan-500 text-cyan-500 hover:text-white hover:bg-cyan-500 focus:outline-none focus:bg-cyan-500 focus:text-white">
                        Sélectionnez tout
                    </button>
                    <div class="relative inline-block text-left">
                        <div>
                            <button @click="handleOpenDropdown"
                                    class="mr-2 inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50">
                                Options
                                <svg-vue icon="arrow-down" class="fill-current text-black -mr-1 ml-2 h-5 w-5"></svg-vue>
                            </button>
                            <div v-if="isDropdownOpen" v-click-away="handleCloseDropdown"
                                 class="z-50 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div class="py-1">
                                    <a href="" @click.prevent="handleDeleteSelection"
                                       class="text-red-700 block px-4 py-2 text-sm">Supprimer</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Draggable
                        handle=".input-handle"
                        class="mt-6 grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:mt-8"
                        v-model="files"
                        @dragend="handleDragEnd"
                    >
                        <transition-group name="list">
                            <div v-for="file in files" class="col-span-1 p-0 bg-gray-50 m-2" :key="file.id">
                                <div class="relative">
                                    <Loader v-if="this.selection.includes(file.id) && isDeletePending"
                                            class="absolute -mt-6 -ml-6 w-12 h-12 top-1/2 left-1/2"/>
                                    <img
                                        :src="file.file ? file.file.responsiveUrls[0] : '/img/estate-default.png'"
                                        alt=""
                                        class="h-64 w-full object-cover rounded-sm"
                                        @error="handleCoverError"
                                    >
                                    <div class="absolute top-1 right-1">
                                        <a :href="file.file ? file.file.url : '#'" target="_blank" download>
                                            <svg-vue icon="import" class="fill-current text-white w-6 h-6"></svg-vue>
                                        </a>
                                    </div>
                                    <div class="absolute top-1 left-2">
                                        <input id="comments" name="comments" v-model="selection" :value="file.id"
                                               type="checkbox"
                                               class="focus:ring-cyan-500 h-4 w-4 text-cyan-500 border-gray-300 rounded">
                                    </div>
                                    <span
                                        class="input-handle rounded-t cursor-move flex flex-row items-center py-2 flex-1">
                                            <svg-vue icon="draggabledots" class="h-4 w-4 fill-cyan-800"></svg-vue>
                                        </span>
                                </div>
                            </div>
                        </transition-group>
                    </Draggable>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Select from "../../components/form/select"
import {directive} from "vue3-click-away";
import Loader from "../../components/partials/loader"
import {VueDraggableNext} from 'vue-draggable-next'
import PageHeader from "../../components/partials/page-header";

export default {
    beforeMount() {
        if (!this.domain || this.domain.id !== this.$route.params.domain_id) {
            this.$store.dispatch('domains/getSingle', {id: this.$route.params.domain_id, includes: ['projects', 'settings', 'files']})
        }
    },
    data() {
        return {
            selection: [],
            activeCategory: 'images',
            isDropdownOpen: false,
        }
    },
    computed: {
        isImagesPending() {
            return this.$store.state.files.isFetchListPending
        },
        domain() {
            return this.$store.state.domains.single;
        },
        files: {
            get() {
                return this.domain && this.domain.files ? this.domain.files.data : [];
            },
            set(list) {
                return this.domain.files.data = list;
            }
        },
        isDeletePending() {
            return this.$store.state.files.isDeletePending;
        }
    },
    methods: {
        handleOpenDropdown() {
            this.isDropdownOpen = true;
        },
        handleCloseDropdown() {
            this.isDropdownOpen = false;
        },
        handleUploadMedias() {
            this.$store.dispatch('upload/resetList')
            this.$store.dispatch('modals/open', 'images-upload')
        },
        handleDeleteSelection() {
            if (this.selection.length > 0) {
                this.$store.dispatch('files/upload', {removes: this.selection}).then(() => {
                    this.selection.forEach((id) => {
                        if (this.files.findIndex(file => file.id === id) !== -1) {
                            this.files.splice(this.files.findIndex(file => file.id === id), 1);
                        }
                    })
                    this.selection = []
                })
            }

            this.isDropdownOpen = false
        },
        handleSelectAll() {
            this.selection = this.selection.length > 0 ? [] : this.files.map(image => image.id);
        },
        handleDragEnd() {
            this.$store.dispatch('files/move', {movedFields: this.files});
        }
    },
    components: {
        Draggable: VueDraggableNext,
        Select,
        Loader,
        PageHeader
    },
    directives: {
        ClickAway: directive
    }
}
</script>

<style>
    .list-move,
    .list-enter-active,
    .list-leave-active {
        transition: all 0.5s ease;
    }
    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
    .list-leave-active {
        position: absolute;
    }
</style>


